<!--  -->
<template>
  <div>
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input v-model="query.keywords" clearable style="width:300px;margin-right:10px" placeholder="请输入员工编号/企业成员id" />
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <!-- <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button> -->
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      max-height="650"
      border
    >
      <el-table-column
        prop="id"
        label="id"
        align="center"
        width="50px"
      />
      <el-table-column
        prop="employee_no"
        label="员工编号"
        align="center"
        width="250px"
      />
      <el-table-column
        prop="name"
        label="员工名字"
        align="center"
        width="100"
      />
      <el-table-column
        prop="user_id"
        label="企业成员userid"
        align="center"
        width="250px"
      />
      <el-table-column
        prop="external_user_id"
        label="外部联系人userid"
        align="center"
        width="300"
      />
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
      />
      <el-table-column
        prop="description"
        label="描述"
        align="center"
      />
      <el-table-column
        prop="add_way"
        label="客户的来源"
        align="center"
      >
        <template slot-scope="scope">
          {{ fifter(scope.row.add_way) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { externalContactsList } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        external_user_id: null,
        keywords: null
      },
      loading: false,
      tableData: [],
      total: null,
      arr: [
        {
          id: 0,
          name: '未知来源'
        },
        {
          id: 1,
          name: '扫描二维码'
        },
        {
          id: 2,
          name: '搜索手机号'
        },
        {
          id: 3,
          name: '名片分享'
        },
        {
          id: 4,
          name: '群聊'
        },
        {
          id: 5,
          name: '手机通讯录'
        },
        {
          id: 6,
          name: '微信联系人'
        },
        {
          id: 8,
          name: '安装第三方应用时自动添加的客服人员'
        },
        {
          id: 9,
          name: '搜索邮箱'
        },
        {
          id: 10,
          name: '视频号添加'
        },
        {
          id: 11,
          name: '通过日程参与人添加'
        },
        {
          id: 12,
          name: '通过会议参与人添加'
        },
        {
          id: 13,
          name: '添加微信好友对应的企业微信'
        },
        {
          id: 14,
          name: '通过智慧硬件专属客服添加'
        },
        {
          id: 15,
          name: '通过上门服务客服添加'
        },
        {
          id: 16,
          name: '通过获客链接添加'
        },
        {
          id: 201,
          name: '内部成员共享'
        },
        {
          id: 202,
          name: '管理员/负责人分配'
        }
      ]
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(id) {
      this.query.external_user_id = id
      this.list()
    },
    async list() {
      this.loading = true
      const data = await externalContactsList(this.query)
      // var time = setInterval(() => {
      //   console.log('111')
      //   data.data.list.forEach(element => {
      //     this.tableData.push(element)
      //   })
      //   if (this.tableData.length === 10) {
      //     clearInterval(time)
      //   }
      // }, 1000)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    fifter(id) {
      const index = this.arr.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items.id == id
      })
      // eslint-disable-next-line eqeqeq
      if (index == -1) {
        return ''
      } else {
        return this.arr[index].name
      }
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
